import { tns } from 'tiny-slider/src/tiny-slider';

class BlockProduct {
	constructor(el) {
		this.el = el;
		this.sliderContainer = this.el.querySelector('.block-product__slider');
		this.navContainer = this.el.querySelector('.block-product__nav-container');
		this.slidesCount = this.sliderContainer.children.length;

		this.responsive = {
			default: {
				items: 1
			},
			768: {
				items: 2
			},
			1024: {
				items: 3
			}
		};

		this.initSlider();
		this.createNavDots();

		// Update nav dots on window resize
		window.addEventListener('resize', this.createNavDots.bind(this));
	}

	getItemsPerPage() {
		const viewportWidth = window.innerWidth;

		if (viewportWidth >= 1024) {
			return this.responsive[1024].items;
		}
		if (viewportWidth >= 768) {
			return this.responsive[768].items;
		}
		return this.responsive.default.items;
	}

	createNavDots() {
		this.navContainer.innerHTML = ''; // Clear existing dots
		const itemsPerPage = this.getItemsPerPage();
		const pagesCount = Math.ceil(this.slidesCount / itemsPerPage);

		for (let i = 0; i < pagesCount; i++) {
			const dot = document.createElement('div');
			this.navContainer.appendChild(dot);
		}
	}

	initSlider() {
		tns({
			container: this.sliderContainer,
			controls: false,
			autoHeight: true,
			axis: 'horizontal',
			swipeAngle: false,
			speed: 400,
			rewind: true,
			nav: true,
			navContainer: this.navContainer,
			mouseDrag: true,
			slideBy: 'page',
			items: 1,
			edgePadding: 0,
			gutter: 40,
			responsive: {
				768: this.responsive[768],
				1024: this.responsive[1024]
			}
		});
	}
}

export default BlockProduct;
